import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/api/common/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NoLoggedInGuard {
  public constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.isLoggedInObservable().pipe(
      map(isLoggedIn => {
        if (isLoggedIn) {
          return this.router.parseUrl('/home');
        } else {
          return true;
        }
      }),
    );
  }
}
